import { render, staticRenderFns } from "./AdmissionConsult.vue?vue&type=template&id=2d43618b&scoped=true"
import script from "./AdmissionConsult.vue?vue&type=script&lang=js"
export * from "./AdmissionConsult.vue?vue&type=script&lang=js"
import style0 from "./AdmissionConsult.vue?vue&type=style&index=0&id=2d43618b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d43618b",
  null
  
)

export default component.exports